"use strict";
import Swiper from 'swiper';

const swiper = new Swiper(".swiper", {
    direction: "horizontal",
    slidesPerView: 5,
    freeMode: true,
    loop: false,
    
    breakpoints: {
        320: {
            slidesPerView: 3.5,
            spaceBetween: "10",
        },
        992: {
            slidesPerView: "auto",
            spaceBetween: 10,
        }
    },
});

// set slider autoplay false
$(".breed-details-slider").carousel({
    interval: false
});

var $swiperSlide = $(".breed-details-thumbnails .swiper-slide");
$(".breed-details-thumbnails .swiper-slide").on("click", function () {
    $swiperSlide.removeClass("active"); 
    $(this).addClass("active");
});

// Get the modal
var modal = document.getElementById('myModal');

// Get the image and insert it inside the modal - use its "alt" text as a caption
var modalImg = document.getElementById("modalImg");

$('img.img-fluid.d-block').on("click", function () {
    modal.style.display = "block";
    modalImg.src = this.src;
    modalImg.alt = this.alt;
});

// When the user clicks on <span> (x), close the modal
$('#myModal').on("click", function () {
    modalImg.className += " out";
    setTimeout(function() {
       modal.style.display = "none";
       modalImg.className = "modal-content";
     }, 200);
});
